<app-section>
  <div class="tab-section">
    <app-alert [alert]="alert"></app-alert>
    <app-form-header [title]="'Training recorded'"></app-form-header>
    <div class="usesrs-details">
      <app-table-grid
        [headers]="trainingsHeaders"
        [data]="trainings"
        [noRecordTxt]="'No training record found.'"
      ></app-table-grid>
    </div>
  </div>
</app-section>
<div class="sticky-btns" *ngIf="showBackCPQPNavigationButton">
  <app-section>
    <div class="sticky-btn-container">
      <app-button
        [name]="'Back to CP/QP Nominations'"
        [type]="'secondary'"
        (btnClick)="onBackToWorkFlow()"
        [textTransformNone]="true"
      >
      </app-button>
    </div>
  </app-section>
</div>
